import {
  Component,
  OnInit,OnDestroy
} from '@angular/core';
import {
  Location
} from '@angular/common';
import {
  AccountService
} from '../../../_services';
import {
  UntypedFormBuilder,
  UntypedFormGroup
} from '@angular/forms';
import {
  validate,
  parse
} from 'fast-xml-parser';
import {Subscription} from 'rxjs';
import {WebServiceParam} from  '../../../_models/web-service-param';
@Component({
  templateUrl: 'dgx-html-response.component.html',
  styleUrls: ['../../../../assets/css/common.css'],
})
export class DGXHTMLResponseComponent implements OnInit,OnDestroy {
  isLoading:boolean=false;
  private webServiceParamStatusSub:Subscription;
  webServiceParam: WebServiceParam[]=[];
  returnUrl: string;
  combine: string = "";
  sub: any;
  file: string;
  title: string;
  length: any;
  xmlRequest: any;
  routeXmlResponse: any;
  validateRequest: boolean = false;
  validateResponse: boolean = false;
  ErrorResponse: boolean = false;
  form: UntypedFormGroup;
  code: string;
  msg: string;
  line: number;
  htmlJsonItems: any;
  htmlTraverseItems: any;
  htmlOutputItems: any;
  constructor(
    private accountService: AccountService,
    private _location: Location,
    private formBuilder: UntypedFormBuilder,
  ) {}
  ngOnInit() {
    this.isLoading=true; 
    this.htmlTraverseItems = {};
    this.form = this.formBuilder.group({
      routeXmlcontent: ['']
    });
     
    this.webServiceParamStatusSub=  this.accountService.getWebServiceParamUpdateListener().subscribe((serviceData:{webServiceParam:WebServiceParam[]}) =>{
      this.webServiceParam=serviceData.webServiceParam;
      console.log(this.webServiceParam);
      console.log(this.webServiceParam['serviceResponseXmlContent']);
   var formattedXmlResponseContent = this.accountService.beautify(this.webServiceParam["serviceResponseXmlContent"],'xml',false);
       console.log(this.webServiceParam["serviceXmlValidateResponse"]);
    if (this.webServiceParam["serviceXmlValidateResponse"]== true) {
        var result = validate(formattedXmlResponseContent);
        if (result != true) {
          this.isLoading=false;
          console.log("result false");
          this.ErrorResponse = true;
          var obj = result.err;
          this.code = obj.code;
          this.msg = obj.msg;
          this.line = obj.line;
          this.form.patchValue({
            routeXmlContent: formattedXmlResponseContent
          });
          this.routeXmlResponse=formattedXmlResponseContent
          this.title=this.webServiceParam['serviceTitleXmlContent'];
          return;
        }
        }
        
         if(formattedXmlResponseContent){
           this.isLoading=false;
           this.form.patchValue({
             routeXmlContent: formattedXmlResponseContent
             });
           this.routeXmlResponse= formattedXmlResponseContent
           this.title=this.webServiceParam['serviceTitleXmlContent'];
         }
    this.htmlJsonItems = this.parseXML(this.webServiceParam["serviceResponseXmlContent"]);
    this.htmlOutputItems = this.traverse(this.htmlJsonItems);
    });
  
  }
  traverse(obj, preKey = "") {
    if (typeof obj == 'object') {
      for (var key in obj) {
        this.traverse(obj[key], (preKey) + (preKey ? "-" + key + "-" : key))
      }
    } else {
      var parentKeys = "";
      preKey = preKey.substring(0, preKey.length - 1);
      key = preKey;
      var keyParts = preKey.split("-");
      var start = 3;
      if (keyParts.length >= 10) {
        start = 5;
      }
      for (var i = start; i < keyParts.length; i++) {
        if (typeof keyParts[i] !== "undefined" && keyParts[i] != "" && keyParts[i] != "__cdata") {
          parentKeys = parentKeys + keyParts[i] + "-";
        }
      }
      parentKeys = parentKeys.substring(0, parentKeys.length - 1);
      key = parentKeys;
      this.htmlTraverseItems[key] = obj;
    }
    return this.htmlTraverseItems;
  }
  backClicked() {
    this._location.back();
  }
  parseXML(xmlData) {
    var options = {
      attributeNamePrefix: "@_",
      attrNodeName: "attr", //default is 'false'
      textNodeName: "#text",
      ignoreAttributes: true,
      ignoreNameSpace: false,
      allowBooleanAttributes: false,
      parseNodeValue: true,
      parseAttributeValue: false,
      trimValues: true,
      cdataTagName: "__cdata", //default is 'false'
      cdataPositionChar: "\\c",
      parseTrueNumberOnly: false,
      arrayMode: false, //"strict"
      stopNodes: ["parse-me-as-string"]
    };
    try {
      var jsonObj = parse(xmlData, options, true);
    } catch (error) {
      //console.log(error.message);
    }
    return jsonObj;
  }
  ngOnDestroy()
  {
    this.webServiceParamStatusSub.unsubscribe();
  }
}